"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointStyle = void 0;

var _styledComponents = require("../styled-components");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var breakpointStyle = function breakpointStyle(breakpoint, content) {
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media only screen ", " {\n    ", ";\n  }\n"])), breakpoint.value && "and (max-width: ".concat(breakpoint.value, "px)"), content);
};

exports.breakpointStyle = breakpointStyle;